import { getEnv } from './env';

export const getCountries = (roles) => {
  let countries = [];
  let isUserAdmin = false;
  if (roles) {
    roles.map(role => {
      if (role?.startsWith("country_")) {
        countries.push(role.split("_")[1].toUpperCase());
      }
      if (role === "admin") {
        isUserAdmin = true;
      }
    });
  }
  if (isUserAdmin) {
    return ["admin"];
  }
  return countries;
};

export const getRegionCountries = (userRoles) => {
  const roleCountries = getCountries(userRoles);
  if (roleCountries.includes("admin")) {
    const countryCodes = getEnv('REACT_APP_COUNTRIES');
    const countries = countryCodes.split(",").map((code, index) => ({
      id: index,
      name: code,
      value: code
    }));
    return countries;
  } else {
    return roleCountries.map((code, index) => ({
      id: index,
      name: code,
      value: code
    }));
  }
};